"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var hslBuilder_1 = __importDefault(require("@haptik/helpers/build/esm/hslBuilder"));
var hslDisplay_1 = __importDefault(require("@haptik/helpers/build/esm/hslDisplay"));
var tabs_1 = __importDefault(require("relements/build/esm/ui/tabs"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var styled_components_1 = __importDefault(require("styled-components"));
// Icons
var InfoIconV4_1 = __importDefault(require("relements/build/esm/ui/icons/InfoIconV4"));
// Store
var store_1 = __importDefault(require("@src/store"));
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var const_1 = require("@src/const");
// Components
var OCDropdown_1 = __importDefault(require("@src/components/OCDropdown"));
var RHSLoader_1 = __importDefault(require("@src/components/BotResponses/RHSLoader"));
// Wrapper Component for Tabs
var wrapperStyles = function (props) {
    var theme = props.theme;
    return {
        margin: '16px 0px 12px 12px',
        border: "1px solid " + theme.colors.grey.neon,
        borderRadius: theme.radii.lg,
        width: 'fit-content',
        padding: "0 " + theme.space.md + "px 0 " + theme.space.md + "px",
    };
};
var TabWrapper = styled_components_1["default"](box_1["default"])(wrapperStyles);
var HSLWrapperStyles = function (props) {
    var theme = props.theme;
    return {
        padding: theme.space.md,
        paddingBottom: 0,
        marginTop: 6,
        borderRadius: theme.radii.sm,
        border: "1px solid " + theme.colors.grey.haptik,
        flexDirection: 'column',
        maxWidth: 364,
    };
};
var HSLWrapper = styled_components_1["default"](box_1["default"])(HSLWrapperStyles);
var LinkWrapper = styled_components_1["default"].a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  span {\n    ", "\n  }\n"], ["\n  text-decoration: none;\n  span {\n    ", "\n  }\n"])), function (props) { return "color: " + props.theme.colors.blue.haptik + ";"; });
var FeedbackMessagesContainer = styled_components_1["default"](box_1["default"])({
    paddingLeft: 12,
    flexDirection: 'column',
    maxWidth: 496,
});
var supportedLanguages = [
    'ar',
    'bn',
    'de',
    'en',
    'es',
    'fr',
    'gu',
    'hi',
    'id',
    'kn',
    'ml',
    'mr',
    'nl',
    'pa',
    'sw',
    'ta',
    'te',
    'tl',
    'zh-CN',
    'zh-TW',
];
var FeedbackMessages = function (_a) {
    var _b = _a.botFeedbackMessages, botFeedbackMessages = _b === void 0 ? [''] : _b, _c = _a.agentFeedbackMessages, agentFeedbackMessages = _c === void 0 ? [''] : _c, onChange = _a.onChange, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.hybridLanguages, hybridLanguages = _e === void 0 ? [] : _e, handleHybridLanguageScriptChange = _a.handleHybridLanguageScriptChange, currentHybridLanguage = _a.currentHybridLanguage, languageSource = _a.languageSource, currentChannel = _a.currentChannel, currentChannelName = _a.currentChannelName, handleOCDropdownChange = _a.handleOCDropdownChange, webSDKSaved = _a.webSDKSaved, isTranslateLoading = _a.isTranslateLoading, _f = _a.isTranslated, isTranslated = _f === void 0 ? false : _f, _g = _a.isAgentFeedbackEnabled, isAgentFeedbackEnabled = _g === void 0 ? true : _g;
    var isDisabled = !supportedLanguages.includes(currentHybridLanguage);
    var handleHybridTabChange = react_1["default"].useCallback(function (script) {
        handleHybridLanguageScriptChange(script);
    }, [handleHybridLanguageScriptChange]);
    var renderHybridLanguageTabs = react_1["default"].useMemo(function () {
        var tabData = [];
        if (hybridLanguages && hybridLanguages.length > 0) {
            hybridLanguages.forEach(function (item) {
                tabData.push(react_1["default"].createElement(tabs_1["default"].Item, { value: item.script, onClick: function () { return handleHybridTabChange(item.script); } }, item.native_name));
            });
        }
        return tabData;
    }, [handleHybridTabChange, hybridLanguages]);
    var renderHSL = function (type) {
        var hslProps = {
            value: type === 'bot' ? botFeedbackMessages[0] : agentFeedbackMessages[0],
            onChange: function (value) { return onChange(value, type, currentChannel); },
            withVariants: false,
            withReplies: true,
            isTranslated: isTranslated,
        };
        if (!disabled) {
            return (react_1["default"].createElement(hslBuilder_1["default"], __assign({ isRephraseEnabled: store_1["default"].getFeatureFlag(MogamboConstants_1.FEATURE_FLAG_DATA.FLAGS.ENABLE_REPHRASE_RESPONSES) && languageSource === 'en', baseUrl: const_1.BASE_URL }, hslProps)));
        }
        return react_1["default"].createElement(hslDisplay_1["default"], __assign({}, hslProps));
    };
    var renderInfoContent = function () {
        return (react_1["default"].createElement(box_1["default"], { padding: "0", marginLeft: "10px", gridGap: "4px", flexDirection: "column" },
            react_1["default"].createElement(text_1["default"], { variant: "body.md" },
                "Feedback is triggered at the logical end of any query.",
                ' ',
                react_1["default"].createElement(LinkWrapper, { href: "https://docs.haptik.ai/user-feedback-collection", target: "_blank", rel: "noopener" },
                    react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Know More")),
                ' '),
            react_1["default"].createElement(text_1["default"], { variant: "body.md" },
                "Please note, if you edit the below feedback messages, then you will also have to adjust your Feedback Smart-Skills (Bot and Agent) to work with the new copies.",
                ' ',
                react_1["default"].createElement(LinkWrapper, { href: "https://docs.haptik.ai/user-feedback-collection/how-to-edit-the-feedback-smart-skill", target: "_blank", rel: "noopener" },
                    react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Know More")),
                ' ')));
    };
    var renderNonSupportedText = function () {
        return (react_1["default"].createElement(box_1["default"], { padding: "0", marginLeft: "10px", gridGap: "4px", flexDirection: "column" },
            react_1["default"].createElement(text_1["default"], { variant: "body.md" },
                "Feedback is currently not supported for this language.",
                ' ')));
    };
    if (isDisabled) {
        return (react_1["default"].createElement(box_1["default"], { backgroundColor: "red.pastel", borderRadius: "sm", width: "fit-content", margin: "0px 0px 12px 12px", padding: "12px", alignItems: "center" },
            react_1["default"].createElement(InfoIconV4_1["default"], { size: "medium", iconColor: "red.dark" }),
            renderNonSupportedText()));
    }
    return (react_1["default"].createElement("div", null,
        react_1["default"].createElement(box_1["default"], { backgroundColor: "yellow.pastel", borderRadius: "sm", width: "fit-content", margin: "0px 12px 12px 12px", padding: "12px", alignItems: "center" },
            react_1["default"].createElement(InfoIconV4_1["default"], { size: "medium", iconColor: "yellow.dark" }),
            renderInfoContent()),
        hybridLanguages && (react_1["default"].createElement(TabWrapper, null,
            react_1["default"].createElement(tabs_1["default"], { themed: true, value: currentHybridLanguage }, renderHybridLanguageTabs))),
        react_1["default"].createElement(OCDropdown_1["default"], { selectedChannel: parseInt(currentChannel, 10), onOCDropDownChange: handleOCDropdownChange, showChannelChangeError: webSDKSaved, style: {
                maxWidth: 390,
            } }),
        react_1["default"].createElement(FeedbackMessagesContainer, null,
            react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column" },
                react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Feedback Message for Bots"),
                react_1["default"].createElement(HSLWrapper, null, !isTranslateLoading ? (renderHSL('bot')) : (react_1["default"].createElement(RHSLoader_1["default"], { relativeAlign: true, text: "Loading " + currentChannelName + " translations" })))),
            isAgentFeedbackEnabled && (react_1["default"].createElement(box_1["default"], { padding: "0", marginTop: "24px", flexDirection: "column" },
                react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Feedback Message for Agents"),
                react_1["default"].createElement(HSLWrapper, null, !isTranslateLoading ? (renderHSL('agent')) : (react_1["default"].createElement(RHSLoader_1["default"], { relativeAlign: true, text: "Loading " + currentChannelName + " translations" }))))))));
};
exports["default"] = FeedbackMessages;
var templateObject_1;
